// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2c_TD","top":"styles_top__2YiV5","left":"styles_left__2Hu_5","description":"styles_description__3aaF9"};